import { useEffect, useRef, useState } from 'react';

export default function HeroSection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    setVisible(true);
  }, []);

  const scrollToSection = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      ref={ref}
      className="relative min-h-[100vh] flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20calm%20minimalist%20workspace%20with%20soft%20warm%20natural%20light%20streaming%20through%20a%20window%20gentle%20beige%20and%20white%20tones%20a%20single%20green%20plant%20a%20cup%20of%20tea%20open%20journal%20on%20a%20wooden%20desk%20peaceful%20serene%20atmosphere%20Muji%20inspired%20aesthetic%20editorial%20photography%20style%20no%20people%20warm%20whites%20soft%20shadows&width=1920&height=1080&seq=hero1&orientation=landscape"
          alt="Calm intentional workspace"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-charcoal-400/40 via-charcoal-400/30 to-charcoal-400/50" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-6 md:px-10 lg:px-16 text-center">
        <div className="max-w-4xl mx-auto">
          <p
            className={`text-white/70 text-xs md:text-sm tracking-[0.3em] uppercase mb-6 md:mb-8 transition-all duration-1000 ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
          >
            A Movement for Intentional Stewardship
          </p>

          <h1
            className={`font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl text-white font-medium leading-[1.15] tracking-tight transition-all duration-1000 delay-200 ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            Make money serve
            <br />
            <span className="italic font-light">what matters.</span>
          </h1>

          <p
            className={`mt-6 md:mt-8 text-white/75 text-base md:text-lg max-w-2xl mx-auto leading-relaxed font-light transition-all duration-1000 delay-400 ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            A practice-based approach to financial stewardship for people earning enough but still feeling trapped.
          </p>

          <div
            className={`mt-10 md:mt-12 flex flex-col sm:flex-row items-center justify-center gap-4 transition-all duration-1000 delay-600 ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            <button
              onClick={() => scrollToSection('#philosophy')}
              className="bg-white text-charcoal-400 px-8 py-3.5 rounded-full text-sm font-medium hover:bg-cream-100 transition-all duration-300 whitespace-nowrap"
            >
              Start Practicing
            </button>
            <button
              onClick={() => scrollToSection('#philosophy')}
              className="border border-white/30 text-white px-8 py-3.5 rounded-full text-sm font-medium hover:bg-white/10 transition-all duration-300 whitespace-nowrap"
            >
              Read the Philosophy
            </button>
          </div>
        </div>
      </div>

      {/* Scroll indicator — direct child of section so it anchors to the true bottom of the viewport */}
      <div
        className={`absolute bottom-6 left-1/2 -translate-x-1/2 z-10 transition-all duration-1000 delay-[1200ms] ${
          visible ? 'opacity-100' : 'opacity-0'
        }`}
      >
        <div className="w-5 h-8 rounded-full border border-white/30 flex items-start justify-center pt-2 animate-float">
          <div className="w-1 h-1.5 bg-white/50 rounded-full" />
        </div>
      </div>
    </section>
  );
}